import { useEffect }          from 'react';
import { store }              from 'index';
import { appTopicsArrType }   from 'types';
import { componentsStateType } from 'reducer/types';

import { SET_CHANGE_CONTENT } from 'actions/contentActions';
import create_topic_arr       from 'functions/set_data/create_topic_arr';

const useChangeContent = (
  componentsState: componentsStateType,
  changeContent:   boolean,
  setAppTopicsArr: (val: appTopicsArrType[]) => void
) => {
   
  useEffect(() => {

    if ( changeContent ) {

      import("functions/set_data/filter_content").then(func => {
        func.filterContent(componentsState, setAppTopicsArr , create_topic_arr);
      });
      store.dispatch(SET_CHANGE_CONTENT(false));
    }


  },[changeContent, componentsState,  setAppTopicsArr])

}

export default useChangeContent

